import { gql } from "graphql-request";

const CreateCentralizationQuery = gql`
  mutation CreateCentralization($input: CentralizationInputDto!) {
    CreateCentralization(input: $input) {
      error
      messege
      status
    }
  }
`;
export default CreateCentralizationQuery;
